module.exports = __webpack_public_path__ + "static/media/tamandua-bandeira.9ab5d680.mp3";